import { WheelEventCommand } from '@canvas/databases-bridge-api/commands';
import { type RovoContentBridgeAPI, type client } from '@canvas/rovo-content-bridge-api';

export function forwardWheelEventToBridge(
  event: WheelEvent,
  bridge: RovoContentBridgeAPI,
  localClientId: ReturnType<typeof client>,
  externalClientId: ReturnType<typeof client>
): void {
  bridge.send(WheelEventCommand, {
    senderId: localClientId,
    receiverId: externalClientId,
    wheelEvent: {
      deltaX: event.deltaX,
      deltaY: event.deltaY,
      clientX: event.clientX,
      clientY: event.clientY,
      ctrlKey: event.ctrlKey,
      metaKey: event.metaKey,
      shiftKey: event.shiftKey,
      viewportWidth: document.documentElement.clientWidth,
      viewportHeight: document.documentElement.clientHeight,
    },
  });
}
